import { createLogic } from 'redux-logic';
import { dialogLoadMappingsUsed } from '../actions';

const loadDialogMappingsUsed = createLogic({
    type: dialogLoadMappingsUsed,
    latest: true,
    warnTimeout: 0,
    transform({ action }, next) {
        let mappingsUsed = [];
        action.payload.forEach((field) => {
            mappingsUsed =
                field.fieldMapping && field.fieldMapping.targetPath !== ''
                    ? [...mappingsUsed, field.fieldMapping.targetPath]
                    : mappingsUsed;
        });
        next({
            ...action,
            payload: mappingsUsed,
        });
    },
});

export default [loadDialogMappingsUsed];
